import { SEND_DICOUNTS_TO_USERS } from "./actions";
import { ADMIN_DELETE_USER } from "../../user/ducks/actions";

interface UsersState {
  loading: boolean;
  users: any[];
}

const defaultState: UsersState = {
  loading: false,
  users: []
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {

    case "FETCH_USERS_PENDING": {
      return {
        ...state,
        loading: true
      };
    }

    case "FETCH_USERS_FULFILLED": {
      return {
        ...state,
        users: action.payload.data.users,
        loading: false
      };
    }

    case "FETCH_USERS_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    case SEND_DICOUNTS_TO_USERS + "_PENDING": {
      return {
        ...state,
        loading: true
      };
    }

    case SEND_DICOUNTS_TO_USERS + "_FULFILLED": {
      return {
        ...state,
        loading: false
      };
    }

    case SEND_DICOUNTS_TO_USERS + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    case ADMIN_DELETE_USER + "_FULFILLED": {
      const { userId } = action.meta;
      return {
        ...state,
        users: state.users.filter(user => user.id != userId)
      };
    }

    default:
      return state;
  }
};

export default reducer;
